import { ChainIdEnum } from "../../../enums/chain";
import { ChainConfig } from "../types";
import {
  DEFAULT_TOKEN_DECIMALS,
  MARGINX_BRANDING,
  RPC_API_KEY,
} from "./shared";

// ============================================
// SEPOLIA TESTNET (Chain ID: 11155111)
// ============================================
export const sepoliaTestnetConfig: ChainConfig = {
  chainId: ChainIdEnum.SEPOLIA_TESTNET,
  name: "Sepolia Testnet",
  shortName: "sepolia",
  isTestnet: true,
  rpcUrls: [`https://eth-sepolia.g.alchemy.com/v2/${RPC_API_KEY}`],
  explorerUrl: "https://sepolia.etherscan.io",
  l2ExplorerUrl: "https://basecamp.cloud.blockscout.com",
  nativeCurrency: { name: "Ether", symbol: "SepoliaETH", decimals: 18 },
  tokenDecimals: DEFAULT_TOKEN_DECIMALS,
  contracts: {
    erc20: {
      usdc: "0xcC3e3DBb31a7410e1dc5156593CdBFA0616BB309",
      "usdc-native": "",
      usdt: "0xBa63Ccc072C416E6e9Edda1C130DB34F94892Cd5",
      weth: "0xc22B8f9B1656b6335E4E5831b9b827a9f4676729",
      wbtc: "0xe49DEe5353bea74CaF65089237005198a14F7C83",
      l2usdc: "0x52623B37Ff81c53567D6D16fd94638734cCDCf27",
      l2usdt: "0xd1a40a21b3B5C7aEEF62a2454c2570d2f8390570",
      l2weth: "0x80626896A2ad4a8ba69a93C4a519C23be26dD403",
      l2wbtc: "0x643aaB1618c600229785A5E06E4b2d13946F7a1A",
      govToken: "0xF8368119Bb1073Cf01B841848725d81b542A4c19",
    },
    bridge: {
      l1DepositHelper: "0x2179F20809b6155a2222f4BdAE40B65837C1E4c5",
      l1StandardBridge: "0xb459023ECAf4ee7E55BEC136e592d2B7afF482E2",
      l2StandardBridge: "0x4200000000000000000000000000000000000010",
      l2WithdrawProxy: "0x870b65A0816B9e9A0dFCE08Fd18EFE20f245011f",
      exchangePass: "",
      strategies: "0x26bD9348A30838d82814790Cc9EaA42cd6504F2C",
      staking: "",
    },
  },
  signingDomain: { name: "MarginX Sepolia Testnet", version: "1" },
  socketL2ChainId: 11155112,
  branding: MARGINX_BRANDING,
};
